import { render, staticRenderFns } from "./BestaetigenReservierung.vue?vue&type=template&id=3edd1208"
import script from "./BestaetigenReservierung.vue?vue&type=script&lang=ts"
export * from "./BestaetigenReservierung.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports